module.exports = __webpack_public_path__ + "img/brush.7c3ef7ba.svg";